const generateNumberArray = (start, end, step = 1) => {
  if (end < start) {
    return [];
  }

  return Array.from({ length: (end - start) / step + 1 }, (_, i) => start + i * step);
};

export default generateNumberArray